<div *ngIf="buildingEquipment; else noBuildingEquipment" class="tga-card"
     [nbTooltip]="buildingEquipment.sectionText || buildingEquipment.name"
     nbTooltipPlacement="top">
  <span class="tga-card__dot" [style.background]="buildingEquipment.color"></span>
  <span class="tga-card__name">{{ buildingEquipment.name }}</span>
  <button class="tga-card__link" nbButton ghost size="tiny" (click)="navigate($event)" nbTooltip="TGA öffnen">
    <nb-icon pack="eva" icon="external-link-outline"></nb-icon>
  </button>
</div>

<ng-template #noBuildingEquipment>
  <span class="text-hint">—</span>
</ng-template>
